import { Box } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";

const FullPage = () => {
  return (
    <Box display="flex" height="100vh" alignItems="center">
      <Outlet />
    </Box>
  );
};

export default FullPage;
